export default __webpack_public_path__ + "static/media/node-network.6d602163.svg";